var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-page',{attrs:{"title":"Κανονισμός","icon":"mdi-gavel","loading":!_vm.regulations}},[(_vm.regulations)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.regulations.content)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }